/**
 * Agent 浏览器端标识：localStorage 持久化，用于服务端按浏览器隔离会话。
 */
const STORAGE_KEY = 'mp_agent_client_id'

function createId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  return `mp_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 12)}`
}

export function getAgentClientId() {
  try {
    let id = localStorage.getItem(STORAGE_KEY)
    if (id && id.trim() && id.trim().length <= 64) {
      return id.trim()
    }
    id = createId()
    localStorage.setItem(STORAGE_KEY, id)
    return id
  } catch (_) {
    // 隐私模式等无法写 localStorage 时，进程内仍保持稳定
    if (!getAgentClientId._mem) {
      getAgentClientId._mem = createId()
    }
    return getAgentClientId._mem
  }
}

export function agentClientHeaders() {
  return { 'X-Agent-Client-Id': getAgentClientId() }
}
